import * as React from 'react';
import { withPaletteHydration } from '@routes/event/create/CreateWeddingHydration';
import { CreateWedding } from '@routes/event/create/CreateWedding';
import { css } from 'emotion';
import { DesignDemoState } from '../..';
import SlidingPane from 'react-sliding-pane';
import './popup.css';
import { Icon } from '@withjoy/joykit';

const WrappedCreateWedding = withPaletteHydration(CreateWedding);

interface CreateWeddingPopupProps {
  showCreateWeddingModal: boolean;
  handleCreateWeddingClose: () => void;
  designDemoState: DesignDemoState;
}

const popupPosition = css({
  zIndex: 10
});

const ctaText = {
  title: 'Let’s Add Your Details',
  subtitle: `Let's add a few details about your wedding. Don't worry, you can update your details later if you need to.`
};
export const CreateWeddingPopup: React.SFC<CreateWeddingPopupProps> = ({
  showCreateWeddingModal,
  handleCreateWeddingClose,
  designDemoState
}) => (
  <SlidingPane
    closeIcon={<Icon source="close" />}
    overlayClassName={popupPosition}
    width="100vw"
    from="bottom"
    isOpen={showCreateWeddingModal}
    onRequestClose={handleCreateWeddingClose}
  >
    <WrappedCreateWedding
      shouldHydrateStateFromSearch={false}
      designDemoState={designDemoState}
      ctaText={ctaText}
      onHeaderClick={handleCreateWeddingClose}
      inPopup={true}
      popupOpen={showCreateWeddingModal}
    />
  </SlidingPane>
);
